export default "__VITE_ASSET__CbOz50ic__"